import { LanguageProvider } from "./LanguageContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ProductsSection from "./components/ProductsSection";
import IndustrialPsuSection from "./components/IndustrialPsuSection";
import RackRailsSection from "./components/RackRailsSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Impressum from "./components/Impressum";
import Datenschutz from "./components/Datenschutz";
import Footer from "./components/Footer";

function HomePage() {
  return (
    <>
      <Navbar />
      <main className="flex-1">
        <section id="start" className="scroll-mt-24">
          <Hero />
        </section>

        <section id="produkte" className="scroll-mt-24">
          <ProductsSection />
        </section>

        <section id="industrial-psu" className="scroll-mt-24">
          <IndustrialPsuSection />
        </section>

        <section id="rack-rails" className="scroll-mt-24">
          <RackRailsSection />
        </section>

        <section id="about" className="scroll-mt-24">
          <AboutSection />
        </section>

        <section id="contact" className="scroll-mt-24">
          <ContactSection />
        </section>
      </main>
      <Footer />
    </>
  );
}

function ImpressumPage() {
  return (
    <>
      <Navbar />
      <main className="flex-1">
        <Impressum />
      </main>
      <Footer />
    </>
  );
}

function DatenschutzPage() {
  return (
    <>
      <Navbar />
      <main className="flex-1">
        <Datenschutz />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-white text-gray-900 flex flex-col">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}
